import React, { useEffect } from 'react';
import { View } from 'react-native';
import { useQuery } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Fields, defaultValues, prepareInput, useFormSubmit } from 'app/src/elements/forms';
import { Button } from 'app/src/elements/buttons';
import { Loading } from 'app/src/elements/DataState';
import { Notice } from 'app/src/elements/Notice';
import { Title } from 'app/src/styles';
import { useNavigate, useParams } from 'app/src/utils/routing';

import { THING, THINGS, UPDATE_THING } from './queries';
import { FIELDS } from './new';

const Thing = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { control, handleSubmit, reset, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS })
  });

  const { data } = useQuery(THING, { variables: { id } });
  const { data: selects } = useQuery(THINGS, {
    variables: { limit: 100000, offset: 'MA==', options: {} }
  });

  useEffect(() => {
    if (data) {
      reset(defaultValues({ fields: FIELDS, resource: data.thing }));
    }
  }, [data]);

  const { submit: updateThing, formStatus, errorMessage } =
    useFormSubmit(UPDATE_THING, {
      onCompleted: () => navigate('/things'),
    });

  const onSubmit = input => {
    updateThing({
      variables: { input: { id, ...prepareInput(input, FIELDS) } }
    });
  };

  const fields = { ...FIELDS };

  if (selects) {
    fields.parentId.select = [
      { value: '', label: 'NONE' },
      ...selects.things.edges
        .filter(edge => edge.node.id !== id)
        .map(edge => ({ value: edge.node.id, label: edge.node.name }))
    ];
  }

  return (
    <View>
      <Title>{data?.thing.name}</Title>

      <Fields
        fields={FIELDS}
        control={control}
        errors={errors}
      />

      {errorMessage && <Notice type="error">{errorMessage}</Notice>}

      {'submitting' === formStatus ? (
        <Loading />
      ) : (
        <Button label="Save" onPress={handleSubmit(onSubmit)} wide />
      )}
    </View>
  );
};

export default Thing;
